import React, { Component } from 'react';
import { Utils } from '../../utils/utils';
import Sdk from 'api.digitalpages.module.sdk.api';
import './menu.css';

export default class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "color": "#FFF"
    }
  }

  componentWillMount() {
    this.setSecondaryColor()
  }

  setSecondaryColor() {
    this.setState({
      "color": Utils.getCustomizationConfig("common", "tertiary_color")
    })
  }

  getStyle(active) {
    var style = {
      color: "#FFF"
    };

    if (this.props.active === active) {
      var color = this.state.color;
      style.color = color || "#084c8a";
    };

    return style;
  }
  
  onMenuClick() {
    for (let i = 1; i <= 6; i++) {
      window.localStorage.removeItem(`rdp-super-app-checkin-${i}`)
    }
    window.localStorage.setItem(`rdp-super-app-coins`, '[{"type":"sign_up","target":"app","coins":10000}]');
    
    var badges = [];
    for (let i = 0; i < 8; i++) {
      badges.push({
        "label": null,
        "exist": false
      })
    }
    window.localStorage.setItem("rdp-super-app-badges", JSON.stringify(badges));
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  getRole() {
    var roles = Sdk.Api.authorization.user.roles;

    return {
      "graduacao": roles.filter(role => role.type === "Viewer").length > 0,
      "cursos_livres": roles.filter(role => role.type === "LearningViewer").length > 0
    }
  }

  render() {
    var role = this.getRole();
    return (
      <ul className="rdp-react-template-component-menu">
        <li className={`rdp-react-template-component-menu-item ${this.props.active === "home" ? "active" : ""}`} onClick={() => this.redirectTo("/")}>
          <span className="rdp-react-template-component-menu-item-icon">
            <svg style={{width: "22px", height: "19px"}} width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.04319 7.87137L7 0.785763L12.9568 7.87137C13.1462 8.09662 13.25 8.38146 13.25 8.67574V13C13.25 13.6904 12.6904 14.25 12 14.25H2C1.30964 14.25 0.75 13.6904 0.75 13V8.67574C0.75 8.38146 0.853825 8.09662 1.04319 7.87137Z" stroke={this.getStyle("home").color} stroke-width="1.5"/>
            </svg>
          </span>
          <span className="rdp-react-template-component-menu-item-label" style={this.getStyle("home")}>Início</span>
        </li>
        <li className={`rdp-react-template-component-menu-item ${this.props.active === "meu-curso" ? "active" : ""}`} onClick={() => this.redirectTo("/feed")}>
          <span className="rdp-react-template-component-menu-item-icon">
            <svg style={{marginTop: "3px"}} version="1.1" xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
              <path fill={this.getStyle("meu-curso").color} d="M1024 256c0-44.992-30.624-83.456-74.432-93.568l-416.416-96.096c-6.976-1.568-14.080-2.336-21.152-2.336s-14.176 0.768-21.6 2.432l-415.968 96c-43.84 10.112-74.432 48.576-74.432 93.568s30.624 83.456 74.4 93.568l85.6 19.744v270.688c0 84.928 97.216 160 352 160s352-75.072 352-160v-270.688l85.568-19.744c43.808-10.112 74.432-48.576 74.432-93.568zM800 640c0 35.36-96 96-288 96s-288-60.64-288-96v-255.904l266.816 61.568c6.976 1.568 14.112 2.336 21.184 2.336s14.208-0.768 21.568-2.432l266.432-61.472v255.904zM519.2 383.2c-2.4 0.512-4.8 0.8-7.2 0.8s-4.832-0.288-7.2-0.8l-416-96c-14.528-3.36-24.8-16.288-24.8-31.2s10.272-27.84 24.8-31.2l416-96c2.368-0.512 4.768-0.8 7.2-0.8s4.832 0.288 7.2 0.8l416 96c14.496 3.36 24.8 16.288 24.8 31.2s-10.304 27.84-24.8 31.2l-416 96zM928 416c0-17.696 14.304-32 32-32 17.664 0 32 14.304 32 32v288c0 17.696-14.336 32-32 32-17.696 0-32-14.304-32-32v-288zM960 768c35.328 0 64 92.672 64 128s-28.672 64-64 64c-35.36 0-64-28.672-64-64s28.64-128 64-128z"></path>
            </svg>
          </span>
          <span className="rdp-react-template-component-menu-item-label" style={this.getStyle("meu-curso")}>{role.graduacao ? "Meu Curso" : "Conteúdos"}</span>
        </li>
        {role.graduacao &&
          <li className={`rdp-react-template-component-menu-item ${this.props.active === "dashboard" ? "active" : ""}`} onClick={() => this.redirectTo("/desempenho")}>
            <span className="rdp-react-template-component-menu-item-icon">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="768" height="768" viewBox="0 0 768 768">
                <path fill={this.getStyle("dashboard").color} d="M608 640v-320c0-17.664-14.336-32-32-32s-32 14.336-32 32v320c0 17.664 14.336 32 32 32s32-14.336 32-32zM416 640v-512c0-17.664-14.336-32-32-32s-32 14.336-32 32v512c0 17.664 14.336 32 32 32s32-14.336 32-32zM224 640v-192c0-17.664-14.336-32-32-32s-32 14.336-32 32v192c0 17.664 14.336 32 32 32s32-14.336 32-32z"></path>
              </svg>
            </span>
            <span className="rdp-react-template-component-menu-item-label" style={this.getStyle("dashboard")}>Desempenho</span>
          </li>
        }
        <li className={`rdp-react-template-component-menu-item disabled ${this.props.active === "search" ? "active" : ""}`}>
          <span className="rdp-react-template-component-menu-item-icon search"></span>
          <span className="rdp-react-template-component-menu-item-label">Buscar</span>
        </li>
        {/* <li className={`rdp-react-template-component-menu-item ${this.props.active === "checkin" ? "active" : ""}`}>
          <span className="rdp-react-template-component-menu-item-icon checkin"></span>
          <span className="rdp-react-template-component-menu-item-label">Checkin</span>
        </li> */}
        {/* <li className={`rdp-react-template-component-menu-item disabled ${this.props.active === "favorites" ? "active" : ""}`}>
          <span className="rdp-react-template-component-menu-item-icon favorites"></span>
          <span className="rdp-react-template-component-menu-item-label">Favoritos</span>
        </li> */}
        <li className={`rdp-react-template-component-menu-item disabled ${this.props.active === "menu" ? "active" : ""}`} onClick={() => this.onMenuClick()}>
          <span className="rdp-react-template-component-menu-item-icon menu"></span>
          <span className="rdp-react-template-component-menu-item-label">Menu</span>
        </li>
      </ul>
    );
  }
}
